import Category from "./category";
import Collaborators from "./Collaborators";
import Layout from "./Layout";
import Events from "./Events";
import ProjectExportations from "./ProjectExportations";
import Properties from "./Properties";
import Analytics from "./Analytics";
import Log from "./Log";
import Metadata from "./Metadata";
import New from "./New";
import ProjectPage from "./ProjectPage";
import Resource from "./resource";
import ResourceCollections from "./ResourceCollections";
import Resources from "./Resources";
import Social from "./social";
import Text from "./text";
import Texts from "./Texts";
import Wrapper from "./Wrapper";
import Access from "./access";

export default {
  Category,
  Collaborators,
  Layout,
  Events,
  ProjectExportations,
  Properties,
  Log,
  Analytics,
  Metadata,
  New,
  ProjectPage,
  Resource,
  ResourceCollections,
  Resources,
  Social,
  Text,
  Texts,
  Wrapper,
  Access
};
